import React, { useState } from "react";
import "styles/pages/page-suspensions.scss";

import Layout from "components/Layout";
import ScrollTile from "components/ScrollTile/ScrollTile";
import Seo from "components/Seo";
import SubpageHeader from "components/SubpageHeader/SubpageHeader";
import TeamPersonTile from "components/TeamPersonTile/TeamPersonTile";
import VerticalScrollMenu from "components/VerticalScrollMenu/VerticalScrollMenu";
import SectionHeader from "components/SectionHeader/SectionHeader";
import ContactForm from "../components/ContactForm/ContactForm";

const SuspensionsPage = ({ pageContext }) => {
  const [recipient, setRecipient] = useState("");
  const pageContent = pageContext.pageContent;
  const seo = pageContext.seo;
  const team = pageContext.pageContent.suspensionsTeam;
  return (
    <Layout>
      <Seo title={seo.title} description={seo.metaDesc} />
      <SubpageHeader
        title={pageContent.mainTitle}
        subtitle={pageContent.subtitle}
        location={pageContext.title}
        crumbFirstLabel="serwis części i akcesoria"
      />
      <section className="suspensions-about">
        <div className="container">
          <div
            className="suspensions-about__text"
            dangerouslySetInnerHTML={{ __html: pageContent.desc }}
          />
          <div className="row justify-content-center">
            <div className="col-xl-4 col-sm-6">
              <ScrollTile
                title="Pełne zawieszenia <br /> pneumatyczne"
                icon={require("assets/icons/full-suspension.svg").default}
                anchor="zawieszenia-1"
                buttonText="Czytaj więcej"
                shadow={false}
              />
            </div>
            <div className="col-xl-4 col-sm-6">
              <ScrollTile
                title="Wspomagające zawieszenia pneumatyczne"
                icon={require("assets/icons/support-suspension.svg").default}
                anchor="zawieszenia-2"
                buttonText="Czytaj więcej"
                shadow={false}
              />
            </div>
            <div className="col-xl-4 col-sm-6">
              <ScrollTile
                title="Wzmacniane <br /> sprężyny"
                icon={require("assets/icons/springs.svg").default}
                anchor="zawieszenia-3"
                buttonText="Czytaj więcej"
                shadow={false}
              />
            </div>
            <div className="col-xl-4 col-sm-6">
              <ScrollTile
                title="Systemy podpór <br /> hydraulicznych"
                icon={require("assets/icons/hydraulic-support.svg").default}
                anchor="zawieszenia-4"
                buttonText="Czytaj więcej"
                shadow={false}
              />
            </div>
            <div className="col-xl-4 col-sm-6">
              <ScrollTile
                title="Części <br /> specjalne"
                icon={require("assets/icons/special-parts.svg").default}
                anchor="zawieszenia-5"
                buttonText="Czytaj więcej"
                shadow={false}
              />
            </div>
            <div className="col-xl-4 col-sm-6">
              <ScrollTile
                title="Udzielimy informacji i doradzimy najlepsze rozwiązania!"
                icon={require("assets/icons/team-support.svg").default}
                anchor="kontakt"
                buttonText="Skontaktuj się z działem zawieszeń"
                shadow={false}
                contact={true}
              />
            </div>
          </div>
        </div>
      </section>
      <section className="suspensions-content">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <VerticalScrollMenu
                tabs={[
                  {
                    label: "Pełne zawieszenia pneumatyczne",
                    anchor: "zawieszenia-1",
                  },
                  {
                    label: "Wspomagające zawieszenia pneumatyczne",
                    anchor: "zawieszenia-2",
                  },
                  {
                    label: "Wzmacniane sprężyny",
                    anchor: "zawieszenia-3",
                  },
                  {
                    label: "Systemy podpór hydraulicznych",
                    anchor: "zawieszenia-4",
                  },
                  {
                    label: "Części specjalne",
                    anchor: "zawieszenia-5",
                  },
                  { label: "Skontaktuj się z nami!", anchor: "kontakt" },
                ]}
              />
            </div>
            <div className="col-md-9">
              {pageContent.suspensionsContent?.map((node, index) => {
                return (
                  <>
                    <span className="anchor" id={`zawieszenia-${index + 1}`} />
                    <div className="suspensions-content__item" key={index}>
                      <h2 className="suspensions-content__item-title">
                        {node.title}
                      </h2>
                      <div
                        className="suspensions-content__item-content"
                        dangerouslySetInnerHTML={{ __html: node.content }}
                      />
                    </div>
                  </>
                );
              })}
              <div className="service-content__logos-container">
                <h2 className="service-content__logos-title">
                  STOSUJEMY PODZESPOŁY I ROZWIĄZANIA MAREK:
                </h2>
                <div className="service-content__logos">
                  {pageContent.logos?.map((node, index) => {
                    return (
                      <div className="service-content__logo-wrapper">
                        <img
                          src={node.sourceUrl}
                          alt=""
                          className="img-fluid service-content__single-logo"
                          key={index}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <span className="anchor" id="kontakt"></span>
      <section className="suspensions-team">
        <div className="container">
          <SectionHeader
            title="Skontaktuj się z działem zawieszeń!"
            subtitle="NASZ ZESPÓŁ"
            reversed={true}
          />
          <div className="row justify-content-center">
            {team?.map((person, index) => {
              return (
                <div className="col-xl-3 col-md-4 col-sm-6" key={index}>
                  <TeamPersonTile
                    name={person.singleTeam.fullname}
                    jobName={person.singleTeam.jobname}
                    avatar={person.singleTeam.avatar?.sourceUrl}
                    phone={person.singleTeam.phone}
                    email={person.singleTeam.email}
                    onClick={(e) => setRecipient(person.singleTeam.email)}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <span className="anchor" id="formularz"></span>
      <section className="suspensions-contact">
        <ContactForm subject="ZAWIESZENIA" selectedEmail={recipient} />
      </section>
    </Layout>
  );
};

export default SuspensionsPage;
